/**
 * Shared contract for the OPC retest experiment (MER-4429/MER-4944). Referenced by the
 * route guard, RequestASessionService, OnePageCheckoutPageComponent, and QuickCheckoutComponent
 * so producer and consumer resolve to a single source of truth per magic-strings rule.
 */

/** Variant that routes to the One-Page Checkout page. Anything else falls back to QuickCheckout. */
export const OPC_EXPERIMENT_TEST_VARIANT = 'opc';

/** Variant for the QuickCheckout arm and the reporting fallback for non-test outcomes. */
export const OPC_EXPERIMENT_CONTROL_VARIANT = 'control';

/**
 * True when Amplitude assigned the visitor to either arm of the retest. null / off /
 * timeout / unknown all resolve false — those users are outside the experiment
 * population and must not fire exposure or Started.
 */
export function isAssignedOpcVariantKey(key: string | undefined | null): boolean {
  return key === OPC_EXPERIMENT_TEST_VARIANT || key === OPC_EXPERIMENT_CONTROL_VARIANT;
}
